/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';
import ContainedButton from 'components/layout/form/containedButton';
import { Link } from 'react-router-dom';

export const Field = styled.div`
  width: 100%;
  min-height: 78px;
`;

export const ContainerWrapperForm = styled.section`
  color: ${({ theme }) => theme.colors.purple};

  @media (max-width: 768px) {
    width: 100%;
  }

  form {
    display: flex;
    flex-direction: column;
    width: 100%;

    div {
      background-color: white;
    }

    a {
      color: ${(props) => props.theme.colors.purple};
      font-size: 0.875rem;
      text-align: end;
      margin-bottom: 12px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    button {
      margin-bottom: 18px;
    }
  }

  footer {
    a {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: ${({ theme }) => theme.colors.purple};
      font-family: ${(props) => props.theme.font.mangueira.bold};

      svg {
        margin-right: 6px;
        margin-left: -6px;
        margin-top: -3px;
      }
    }
  }
`;

export const Button = styled(ContainedButton)`
  background-color: #3d3d3d;
  width: 100%;

  &:hover {
    opacity: 0.85;
  }

  span {
    font-size: 20px;
    color: ${({ theme }) => theme.colors.white};
    font-weight: 500;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  & > h2 {
    text-align: center;
    margin-bottom: 0;
    color: ${({ theme }) => theme?.colors?.black2};
    font-size: 26px;
    font-family: 'Mangueira Medium';
  }
`;

export const ContainerForm = styled.div`
  width: 100%;
  transition: all 0.5s ease-out;
  max-height: 100%;

  @media (max-width: 1460px) {
    max-height: 500px;
    overflow: hidden;
  }
`;

export const FooterText = styled.p`
  font-family: 'Mangueira', sans-serif;
  margin-bottom: 8px;
  margin-left: 9px;
  margin-top: -10px;
  line-height: 1.5;
  vertical-align: middle;
  padding-top: 10px;
  text-decoration: underline !important;

  &:hover {
    color: #0056b3;
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }
  @media (max-width: 1460px) {
    padding-top: 0px;
  }
`;

export const ContainerImgForm = styled.div`
  max-width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  margin-left: 4px;
`;

export const ImgForm = styled.img``;

export const ContentLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Logo = styled.img`
  width: 50%;
  height: auto;
`;

export const Text = styled.p`
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #636363;
`;

export const Title = styled.p`
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #3d3d3d;
  padding-top: 10px;
  line-height: 1.5;
  vertical-align: middle;

  @media (max-width: 768px) {
    font-weight: 700;
    font-size: 14px;
  }
  @media (max-width: 1460px) {
    padding-top: 2px;
  }
`;

export const LoginOptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 10px 0;
`;

export const RememberMe = styled.label`
  font-family: 'Mangueira', sans-serif;
  display: flex;
  color: #333;
  align-items: center;
  gap: 8px;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const ForgotPassword = styled(Link)`
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  color: #007bff;
  text-decoration: underline !important;

  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 8px;
  }
  &:hover {
    color: #0056b3;
    text-decoration: underline;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: baseline;
  margin-top: 16px;
  gap: 5px;
  justify-content: center;

  @media (max-width: 1460px) {
    margin-top: 0%;
    gap: 0px;
  }
`;

export const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;

  @media (max-width: 1460px) {
    margin-top: 0px;
  }
`;

export const PrivacyText = styled(FooterText)`
  color: #333;
  &:hover {
    color: #1a1a1a;
    text-decoration: underline;
  }
`;
